'use client'
import React, { useEffect } from 'react'
import { useLoaderStore } from '@/stores/useLoaderStore'
import LoadingSpinner from '../LoadingSpinner'

/**
 * Overlay de carregamento da loja (fundo branco translúcido e o spinner da marca). Controlado só pela `useLoaderStore`:
 * requisições com `meta.showLoader`.
 */
const Loader: React.FC = () => {
    const loading = useLoaderStore((state) => state.loading)

    useEffect(() => {
        document.body.style.overflow = loading ? 'hidden' : 'auto'
        return () => {
            document.body.style.overflow = 'auto'
        }
    }, [loading])

    if (!loading) return null

    return (
        <div
            id="loader"
            className="fixed top-0 left-0 z-50 flex flex-col items-center justify-center w-full h-screen bg-white/50 select-none"
            style={{ zIndex: 9999999, display: 'flex' }}
        >
            <LoadingSpinner />
        </div>
    )
}

export default Loader
